import { ServiceLocatorContext } from "context/ServiceLocatorContext";
import { StatContext } from "context/StatContext";
import { useContext, useMemo, useState } from "react";
import { Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import './FormulaBuilder.scoped.scss';

export default function FormulaBuilder() {
    const { stats } = useContext(StatContext);
    const { statComputationService } = useContext(ServiceLocatorContext);
    const [inactiveKeys, setInactiveKeys] = useState({});
    const colors = ['#f00', '#0fa', '#0af', 'yellow', 'orange', 'white', 'grey', 'brown'];
    let colorIndex = 0;

    const chartData = useMemo(() => {
        let dataIndex = 0;
        let data = [];
        stats.forEach(stat => {
            let cache = {};
            for (let i = stat.minIndex; i <= stat.maxIndex; i++) {
                const value = statComputationService.computeStat(stat, i, cache);
                if (!data[i - 1]) {
                    data[i - 1] = { x: i };
                }
                data[i - 1][stat.name] = value;
            }
        });
        return data;
    }, [stats, statComputationService.computedCache]);

    const handleLegendClick = (e) => {
        let newInactiveKeys = { ...inactiveKeys };
        if (!newInactiveKeys[e.value]) {
            newInactiveKeys[e.value] = true;
        } else {
            delete newInactiveKeys[e.value];
        }
        setInactiveKeys(newInactiveKeys);
    };

    return (
        <div className="card flex-col">
            {stats.length === 0 && <div className="no-data flex-col">
                <h2>No data to visualize yet</h2>
            </div>}
            <ResponsiveContainer width="100%" height={180}>
                <LineChart width={100} height={180} data={chartData} style={{ backgroundColor: '#0f1115', borderRadius: '8px', }}
                    margin={{ right: 20, left: 20, }}>
                    {stats.map(stat => <Line strokeWidth={inactiveKeys[stat.name] ? 0 : 1} stroke={inactiveKeys[stat.name] ? 'grey' : colors[colorIndex++]} dot={false} yAxisId={stat.name} type="monotone" key={stat.id} dataKey={stat.name} />)}
                    <Tooltip offset={20} contentStyle={{ backgroundColor: '#0f1115', border: '1px solid grey', fontSize: '14px' }} />
                    <XAxis dataKey="x" />
                    <Legend verticalAlign="top" align="left" onClick={handleLegendClick} wrapperStyle={{ fontSize: '14px' }} />
                </LineChart>
            </ResponsiveContainer>
        </div >
    );
}